import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {
    setActiveVisitForceRefresh,
    setEditReferral,
    setEditReferralLoading,
    setEditReferralReload
} from "../../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import {Accordion, Col, Row, Spinner} from "react-bootstrap";
import axios from "axios";
import {toast} from "react-toastify";
import Button from "react-bootstrap/Button";
import Input from "../../../common/Input";
import moment from "moment/moment";
import BetterCheckBox from "../../../common/BetterCheckBox";
import Modal from "react-bootstrap/Modal";
import {addToForceRefresh} from "../../../../_reducers/SearchTableSlice";
import {getExamTypesOptions} from "./Data/examTypes";
import {downloadReferral, printReferral, sendDigitally} from "./prescriptionFunctions";

const ReferralEdit = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const editReferral = useSelector((state) => state.PRESCRIPTION.editReferral);
    const editReferralReload = useSelector((state) => state.PRESCRIPTION.editReferralReload);
    const editReferralLoading = useSelector((state) => state.PRESCRIPTION.editReferralLoading);

    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const doctorDetails = companyDetails?.prescriptionDoctorDetails;

    const [loadingPrint, setLoadingPrint] = useState(false);

    const [showCancelModal, setShowCancelModal] = useState(false);
    const [loadingCancel, setLoadingCancel] = useState(false);
    const [loadingSendDigitally, setLoadingSendDigitally] = useState(false);

    useEffect(() => {
        if (editReferralReload) {
            dispatch(setEditReferralReload(false));
            fetchEditReferral();
        }
    }, [editReferralReload])

    const fetchEditReferral = () => {
        dispatch(setEditReferralLoading(true));
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/fetch-referral`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                barcode: editReferral.barcode,
                fullSearch: editReferral?.patientsConsent === true,
                amka: editReferral.amka || "", // Only when patientsConsent for mass search
                company: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                const isMine = doctorDetails?.amka === res.data.data.doctorAMKA;
                dispatch(setEditReferral({
                    ...res.data.data,
                    patientsConsent: !isMine ? editReferral.patientsConsent : "",
                    amka: editReferral.amka,
                }));
            } else {
                toast.error(res.data.message);
            }
            dispatch(setEditReferralLoading(false));
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την άντληση παραπεμπτικού.");
            dispatch(setEditReferralLoading(false));
        })
    }

    const handleCancel = () => {
        setLoadingCancel(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/prescription/cancel-referral`, {
            company: company.id,
            barcode: editReferral.barcode,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής ακύρωση παραπεμπτικού.");
                fetchEditReferral();
                setShowCancelModal(false);
                dispatch(addToForceRefresh("Prescription Search Referrals"));
                dispatch(setActiveVisitForceRefresh(true));
            } else {
                toast.error(res.data.message);
            }
            setLoadingCancel(false);
        }).catch((err) => {
            setLoadingCancel(false);
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleDownload = () => {
        downloadReferral(editReferral.barcode, setLoadingPrint, company, {patientsConsent: editReferral.patientsConsent, amka: editReferral.amka});
    }
    const handlePrint = () => {
        printReferral(editReferral.barcode, setLoadingPrint, company, {patientsConsent: editReferral.patientsConsent, amka: editReferral.amka});
    }
    const handleSendDigitally = () => sendDigitally("referrals", editReferral.barcode, setLoadingSendDigitally, company);

    return (
        <React.Fragment>
            {editReferralLoading ? (
                <React.Fragment>
                    <Row className={"mb-2"}>
                        <Col md={12} className={"d-flex justify-content-center"}>
                            Παρακαλώ περιμένετε... <Spinner size={"sm"} className={"ml-2"} animation={"border"} variant={"dark"} />
                        </Col>
                    </Row>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <Row className={"mb-2"}>
                        <Col md={12}>
                            <div style={{textAlign: "center"}}>
                                <h5>Παραπεμπτικό με barcode : <strong>{editReferral.barcode}</strong></h5>
                            </div>
                        </Col>
                    </Row>
                    <Row className={"mb-2"}>
                        <Col md={6}>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Πληροφορίες Ιατρού ({editReferral.doctorName})</Accordion.Header>
                                    <Accordion.Body>
                                        <Row className={"mb-2"}>
                                            <Col md={6}>
                                                <Input
                                                    name={"doctorName"}
                                                    label={"Ονοματεπώνυμο"}
                                                    value={editReferral.doctorName}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <Input
                                                    name={"doctorEmail"}
                                                    label={"E-Mail"}
                                                    value={editReferral.doctorEmail}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className={"mb-2"}>
                                            <Col md={6}>
                                                <Input
                                                    name={"doctorAMKA"}
                                                    label={"ΑΜΚΑ"}
                                                    value={editReferral.doctorAMKA}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <Input
                                                    name={"doctorAMETAA"}
                                                    label={"Α.Μ.Ε.Τ.Α.Α"}
                                                    value={editReferral.doctorAMETAA}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md={6}>
                                                <Input
                                                    name={"doctorSpecialty"}
                                                    label={"Ειδικότητα"}
                                                    value={editReferral.doctorSpecialty}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <Input
                                                    name={"prescriptionUnity"}
                                                    label={"Μονάδα Συνταγογράφησης"}
                                                    value={editReferral.prescriptionUnity}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                        <Col md={6}>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Πληροφορίες Ασθενή ({editReferral.patientName})</Accordion.Header>
                                    <Accordion.Body>
                                        <Row className={"mb-2"}>
                                            <Col md={6}>
                                                <Input
                                                    name={"patientName"}
                                                    label={"Ονοματεπώνυμο"}
                                                    value={editReferral.patientName}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <Input
                                                    name={"patientAMKA"}
                                                    label={"ΑΜΚΑ"}
                                                    value={editReferral.patientAMKA}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className={"mb-2"}>
                                            <Col md={6}>
                                                <Input
                                                    name={"patientSocialInsurance"}
                                                    label={"Φ.Κ.Α."}
                                                    value={editReferral.patientSocialInsurance}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <Input
                                                    name={"patientSocialInsuranceDate"}
                                                    label={"Ημ/νία Λήξης Ασφαλ. Ικανότητας"}
                                                    value={editReferral.patientSocialInsuranceDate}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className={"mb-2"}>
                                            <Col md={4}>
                                                <Input
                                                    name={"patientBirthDate"}
                                                    label={"Ημερομηνία Γέννησης"}
                                                    value={editReferral.patientBirthDate ? moment(editReferral.patientBirthDate, "YYYYMMDD").format("DD/MM/YYYY") : ""}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md={4}>
                                                <Input
                                                    name={"patientSex"}
                                                    label={"Φύλο"}
                                                    value={editReferral.patientSex}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md={4}>
                                                <Input
                                                    name={"patientAMA"}
                                                    label={"AMA"}
                                                    value={editReferral.patientAMA}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className={"mb-2"}>
                                            <Col md={6}>
                                                <Input
                                                    name={"patientSocialInsuranceType"}
                                                    label={"Τύπος Ασφάλισης"}
                                                    value={editReferral.patientSocialInsuranceType}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <Input
                                                    name={"patientAddress"}
                                                    label={"Διεύθυνση"}
                                                    value={editReferral.patientAddress}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className={"mb-2"}>
                                            <Col md={6}>
                                                <Input
                                                    name={"patientCity"}
                                                    label={"Πόλη"}
                                                    value={editReferral.patientCity}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <Input
                                                    name={"patientPostal"}
                                                    label={"Τ.Κ."}
                                                    value={editReferral.patientPostal}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <div className={"mb-3 borderedContainer"}>
                                <h5 style={{fontWeight: "600"}}>Πληροφορίες Παραπεμπτικού</h5>
                                <table style={{width: "100%", fontSize: "16px"}}>
                                    <colgroup>
                                        <col span={1} style={{width: "30%"}}></col>
                                        <col span={1} style={{width: "70%"}}></col>
                                    </colgroup>
                                    <tbody>
                                    <tr>
                                        <td>Κατάσταση</td>
                                        <td style={{textAlign: "right"}}>{editReferral.status}</td>
                                    </tr>
                                    <tr>
                                        <td>Τύπος</td>
                                        <td style={{textAlign: "right"}}>{editReferral.type === "1" ? "Τυπικό" : "Ελεύθερο"}</td>
                                    </tr>
                                    <tr>
                                        <td>Κατηγορία Εξέτασης</td>
                                        <td style={{textAlign: "right"}}>{getExamTypesOptions().find((el) => el.value === editReferral.examType)?.label}</td>
                                    </tr>
                                    <tr>
                                        <td>Ημ/νία Έκδοσης</td>
                                        <td style={{textAlign: "right"}}>{moment(editReferral.startDate, "YYYYMMDDHHmmss").format("DD/MM/YYYY στις HH:mm")}</td>
                                    </tr>
                                    <tr>
                                        <td>Αιτιολογία</td>
                                        <td style={{textAlign: "right"}}>{editReferral.cause}</td>
                                    </tr>
                                    <tr>
                                        <td>Σημειώσεις</td>
                                        <td style={{textAlign: "right"}}>{editReferral.notes || "-"}</td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <BetterCheckBox
                                                className={"mt-2"}
                                                name={"missingEKAS"}
                                                disabled={true}
                                                text={"Απώλεια Ε.Κ.Α.Σ."}
                                                checked={editReferral.missingEKAS}
                                            />
                                        </td>
                                        <td>
                                            <BetterCheckBox
                                                className={"m-0 mt-2"}
                                                name={"zeroParticipationReason"}
                                                disabled={true}
                                                text={"Απαλλαγή ασφαλισμένου από κάθε συμμετοχή"}
                                                checked={![null, undefined, "", "0"].includes(editReferral.zeroParticipationReason)}
                                            />
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </Col>
                        <Col md={6}>
                            {editReferral.diagnoses && (
                                <div className={"mb-3 borderedContainer"}>
                                    <h5 style={{fontWeight: "600"}}>Διαγνώσεις</h5>
                                    <table className={"simpleClassicTable"}>
                                        <colgroup>
                                            <col span={1} style={{width: "30%"}}></col>
                                            <col span={1} style={{width: "70%"}}></col>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>Κωδικός ICD10</th>
                                            <th>Περιγραφή</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {editReferral.diagnoses.map((diag) => (
                                            <tr>
                                                <td>{diag.code}</td>
                                                <td>{diag.displayName}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </Col>
                    </Row>
                    {editReferral?.questions?.length > 0 && (
                        <div className={"mb-3 borderedContainer"}>
                            <h5 style={{fontWeight: "600"}}>Ερωτηματολόγιο</h5>
                            <table className={"simpleClassicTable"}>
                                <thead>
                                <tr>
                                    <th>Ερώτηση</th>
                                    <th>Απάντηση</th>
                                </tr>
                                </thead>
                                <tbody>
                                {editReferral.questions.map((qu, idx) => (
                                    <tr key={`quTable-${idx}`}>
                                        <td>{qu.question}</td>
                                        <td>{qu.selectedAnswer.value} - {qu.selectedAnswer.abbreviation}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                    <div className={"mb-3 borderedContainer"}>
                        <h5 style={{fontWeight: "600"}}>Εξετάσεις</h5>
                        <Row>
                            <Col md={12}>
                                <table className={"simpleClassicTable"}>
                                    <colgroup>
                                        <col span={1} style={{width: "40%"}}></col>
                                        <col span={1} style={{width: "15%"}}></col>
                                        <col span={1} style={{width: "15%"}}></col>
                                        <col span={1} style={{width: "30%"}}></col>
                                    </colgroup>
                                    <thead>
                                    <tr>
                                        <th>Εξέταση</th>
                                        <th>Διάγνωση</th>
                                        <th>Λόγος Παραπομπής</th>
                                        <th>Σχόλια</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {editReferral.exams && editReferral.exams.map((exam, idx) => (
                                        <tr key={`examTable-${idx}`}>
                                            <td>{exam.description}</td>
                                            <td>{exam.erp_icd10}</td>
                                            <td>{exam.erp_reference === "1" ? "Διάγνωση" : "Παρακολούθηση"}</td>
                                            <td>{exam.erp_notes}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </div>
                    {editReferral.overrides && editReferral.overrides?.length > 0 && (
                        <div className={"mb-3 borderedContainer"}>
                            <h5 style={{fontWeight: "600"}}>Εξαιρέσεις/Υπερβάσεις Παραπεμπτικού</h5>
                            <table className={"simpleClassicTable"}>
                                <colgroup>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "35%"}}></col>
                                    <col span={1} style={{width: "20%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Αποδοχή</th>
                                    <th>Διάγνωση</th>
                                    <th>Εξέταση</th>
                                    <th>Περιγραφή</th>
                                    <th>Αιτιολόγηση</th>
                                    <th>Ακυρωμένη</th>
                                </tr>
                                </thead>
                                {editReferral.overrides.map((over, idx) => (
                                    <tr key={`overrides-${idx}`}>
                                        <td style={{zoom: 1.3}}>
                                            <input name={"erp_checked"} type={"checkbox"} checked={over.erp_checked} disabled={true} />
                                        </td>
                                        <td>{over.icd10Code}</td>
                                        <td>{over.exam}</td>
                                        <td>{over.violationDetails}</td>
                                        <td>{over.erp_cause}</td>
                                        <td style={{zoom: 1.3}}>
                                            <input name={"cancelled"} type={"checkbox"} checked={over.cancelled} disabled={true} />
                                        </td>
                                    </tr>
                                ))}
                            </table>
                        </div>
                    )}
                    <div className={"mb-3 borderedContainer"}>
                        <h5 style={{fontWeight: "600"}}>Λοιπά</h5>
                        {!["ΑΚΥΡΩΜΕΝΟ", "ΠΡΟΣΩΡΙΝΑ ΑΠΟΘΗΚΕΥΜΕΝΟ"].includes(editReferral.status) && (
                            <React.Fragment>
                                <Button size={"sm"} onClick={() => handlePrint()} disabled={loadingPrint}>
                                    Εκτύπωση παραπεμπτικού
                                </Button>
                                <Button size={"sm"} className={"ml-1"} onClick={() => handleDownload()} disabled={loadingPrint}>
                                    Λήψη PDF παραπεμπτικού
                                </Button>
                            </React.Fragment>
                        )}
                        {editReferral.status === "ΣΥΝΤΑΓΟΓΡΑΦΗΜΕΝΟ" && (
                            <React.Fragment>
                                <Button size={"sm"} className={"ml-1"} disabled={loadingSendDigitally} onClick={() => handleSendDigitally()}>
                                    Αποστολή παραπεμπτικού σε ηλεκτρονική μορφή
                                </Button>
                                <Button size={"sm"} className={"ml-1"} onClick={() => setShowCancelModal(true)}>
                                    Ακύρωση Παραπεμπτικού
                                </Button>
                            </React.Fragment>
                        )}
                    </div>

                    <Modal show={showCancelModal} onHide={() => setShowCancelModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Ακύρωση Παραπεμπτικού</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Είσαστε σίγουροι ότι θέλετε να ακυρώσετε το παρόν παραπεμπτικό;
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => setShowCancelModal(false)}>
                                Όχι κλείσιμο
                            </Button>
                            <Button variant="primary" onClick={() => handleCancel()} disabled={loadingCancel}>
                                Ναι, ακύρωση {loadingCancel && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default ReferralEdit
